import React from "react";
import Layout from "../../components/Layout";
import { Container, Heading } from "@chakra-ui/react";
import PageHeadingSection from "../../components/PageHeadingSection";

export default function ExemplarGlobal() {
  return (
    <Layout>
      <PageHeadingSection title={"Exemplar Global Calendar"} />
      <Container maxW={"7xl"} py={5}>
        <Heading
          as="h2"
          size="md"
          textAlign={"center"}
          my={5}
          fontWeight={"bold"}
        >
          For Countries: UAE and Gulf
        </Heading>
        <iframe
          src="/training-calendars/EG_Training_Calendar_1.pdf"
          width="90%"
          height="900"
          title="CQI-IRCA Calendar"
          style={{ margin: "auto" }}
        ></iframe>
      </Container>
    </Layout>
  );
}
